import { RcTrans } from '@/components/atoms/RcTrans'
import { RcUserSearch } from '@/components/molecules/input/RcUserSearch'
import { RcButton } from '@/components/molecules/interactive/RcButton'
import { ModalConfiguration } from '@/components/organisms/modal/ModalConfiguration'
import Stack from '@mui/material/Stack'
import { UserDocument } from '@rallycry/api-suite-typescript/dist/models'
import { useState } from 'react'

export const ChatParticipantAdd = ({
  onAdd
}: {
  onAdd: (user?: UserDocument | null) => Promise<any>
}) => {
  const [selected, setSelected] = useState<UserDocument | null>()

  return (
    <Stack direction='row' alignItems='center' spacing={1} pb={2}>
      <RcUserSearch selected={selected} setSelected={setSelected} />

      <ModalConfiguration>
        <RcButton
          disabled={!selected}
          fullWidth
          onClick={() => {
            onAdd(selected)
            setSelected(null)
          }}
        >
          <RcTrans i18nKey='shared.submit' />
        </RcButton>
      </ModalConfiguration>
    </Stack>
  )
}
